import { render, staticRenderFns } from "./RunningCampaigns.vue?vue&type=template&id=548cb359&scoped=true"
import script from "./RunningCampaigns.vue?vue&type=script&lang=ts"
export * from "./RunningCampaigns.vue?vue&type=script&lang=ts"
import style0 from "./RunningCampaigns.vue?vue&type=style&index=0&id=548cb359&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548cb359",
  null
  
)

export default component.exports